import equal from "fast-deep-equal";
import React from "react";
import { useSelector } from "react-redux";

import {
    SearchComponent,
    SearchComponentOfType,
} from "@utils/search/@types/searchComponent";

import { getComponentsState } from "@redux/modules/value/search/search.selectors";

import { NumberOfHitsComponent } from "./numberOfHits.component";

export type NumberOfHitsConfigurationEntry = {
    component: SearchComponentOfType<"NUMBER_OF_HITS">;
    translationKey: string;
    resultListId: string;
};

export const SEARCH_PRODUCT_ID = "search__product";
export const SEARCH_CONTENT_ID = "search__content";

const NumberOfHitsConfiguration: Array<NumberOfHitsConfigurationEntry> = [
    {
        component: SearchComponent.PRODUCT_NUMBER_OF_HITS,
        translationKey: "search.results.name.products",
        resultListId: SEARCH_PRODUCT_ID,
    },
    {
        component: SearchComponent.CONTENT_NUMBER_OF_HITS,
        translationKey: "search.results.name.contentPages",
        resultListId: SEARCH_CONTENT_ID,
    },
];

const NumberOfHits = () => {
    const numberOfHitsComponentsState = useSelector(
        getComponentsState(
            NumberOfHitsConfiguration.map(
                configurationEntry => configurationEntry.component,
            ),
        ),
        equal,
    );

    return (
        <NumberOfHitsComponent
            configuration={NumberOfHitsConfiguration}
            numberOfHitsComponentsState={numberOfHitsComponentsState}
        />
    );
};

export { NumberOfHits };
